// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as SurgeRepoConfig from "./SurgeRepoConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";

var dummyCampaigns = {
        campaigns: [{
          "campaign_name": "Diwali__Dhamaka",
          "id": 1,
          "geo_region": {
            "id": 2,
            "name": "Bangalore"
          },
          "vehicle_types": [
            {
              "id": 1,
              "display_name": "TATA Ace"
            }
          ],
          "surge_strategy": {
            "amount": 200,
            "enum_code": "flat"
          },
          "campaign_start_date": "2019-06-01",
          "campaign_end_date": "2019-06-11",
          "weekdays": ["Sunday", "Monday"],
          "window_start_mins": 125,
          "window_end_mins": 245,
          "administrator": {
            "id": 2,
            "email": "test@xyz.com"
          },
          "status": "active",
          "priority": 1
        },{
          "campaign_name": "Diwali__Dhamaka",
          "id": 1,
          "geo_region": {
            "id": 2,
            "name": "Bangalore"
          },
          "vehicle_types": [
            {
              "id": 1,
              "display_name": "TATA Ace"
            }
          ],
          "surge_strategy": {
            "amount": 200,
            "enum_code": "flat"
          },
          "campaign_start_date": "2019-06-01",
          "campaign_end_date": "2019-06-11",
          "weekdays": ["Wednesday", "Sunday", "Monday", "Thursday"],
          "window_start_mins": 120,
          "window_end_mins": 240,
          "administrator": {
            "id": 2,
            "email": "test@xyz.com"
          },
          "status": "active",
          "priority": 1,
          "zones": [
            {
              "id": 1,
              "description": "Zone 1 address"
            }
          ]
        }]
      };

var dummyGeoRegions = {
        "geo_regions": [
          {
            "id": 1,
            "name": "Mumbai"
          }
        ]
      };

var dummyVehicleTypes = {
        "vehicle_types": [
          {
            "vehicle_id": 1,
            "name": "TATA Ace"
          },
           {
            "vehicle_id": 2,
            "name": "TATA Ace"
          },
           {
            "vehicle_id": 3,
            "name": "TATA Ace"
          },
           {
            "vehicle_id": 4,
            "name": "TATA Ace"
          },
           {
            "vehicle_id": 5,
            "name": "TATA Ace"
          },
           {
            "vehicle_id": 6,
            "name": "TATA Ace"
          },
           {
            "vehicle_id": 7,
            "name": "TATA Ace (Helper)"
          },
           {
            "vehicle_id": 8,
            "name": "3 wheeler (Helper)"
          },
           {
            "vehicle_id": 9,
            "name": "TATA Ace"
          }, {
            "vehicle_id": 10,
            "name": "TATA 407"
          },
           {
            "vehicle_id": 11,
            "name": "Pickup 8ft"
          }

        ]
      };

var dummyZones = {
        "zones": [
          {
            "id": 1,
            "description": "Zone 1 Kormangala 3rd block"
          },
           {
            "id": 2,
            "description": "Zone 2 Kormangala 5th block"
          }
        ]
      };

var dummyCampaignCreateResponse = {
        "success": true,
        "message": "Campaign Created"
      };

var dummyCampaignDeleteResponse = {
        "success": true,
        "message": "Campaign successfully disabled"
      };

var dummyCampaignErrorResponse = {
        "status": "422",
        "error":[
          {
            "type":"Conflicting campaigns",
            "message":"Campaign Ronaldo is already active in Mumbai with priority 1 and administrator swapnil@xyz.com"
          }
        ]
      };

function fetchCampaigns(_geoRegionId, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* SuccessWithNoContent */1,
                              _0: dummyCampaigns
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeCampaignResponseConverter.execute, result);
                        });
            });
}

function fetchGeoRegions(_country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyGeoRegions
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeGeoRegionResponseConverter.execute, result);
                        });
            });
}

function fetchVehicleTypes(_geoRegionId, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyVehicleTypes
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeVehicleTypesResponseConverter.execute, result);
                        });
            });
}

function fetchZones(_geoRegionId, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyZones
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeZonesResponseConverter.execute, result);
                        });
            });
}

function createCampaign(_campaign, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* SuccessWithNoContent */1,
                              _0: dummyCampaignCreateResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeCreateCampaignResponseConverter.execute, result);
                        });
            });
}

function deleteCampiagn(_campaignId, _country) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCampaignDeleteResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SurgeRepoConfig.SurgeDeleteCampaignResponseConverter.execute, result);
                        });
            });
}

var DummySurgeRepo = {
  dummyCampaigns: dummyCampaigns,
  dummyGeoRegions: dummyGeoRegions,
  dummyVehicleTypes: dummyVehicleTypes,
  dummyZones: dummyZones,
  dummyCampaignCreateResponse: dummyCampaignCreateResponse,
  dummyCampaignDeleteResponse: dummyCampaignDeleteResponse,
  dummyCampaignErrorResponse: dummyCampaignErrorResponse,
  fetchCampaigns: fetchCampaigns,
  fetchGeoRegions: fetchGeoRegions,
  fetchVehicleTypes: fetchVehicleTypes,
  fetchZones: fetchZones,
  createCampaign: createCampaign,
  deleteCampiagn: deleteCampiagn
};

export {
  DummySurgeRepo ,
  
}
/* SurgeRepoConfig Not a pure module */
